export class ChartData {
        label: string;
        data: number[];
        borderColor: string;
        backgroundColor: string;
        fill: string;
        pointRadius: number;
        pointHitRadius: number;

    constructor() {
        this.data = Array<number>(12).fill(0);
        this.pointHitRadius = 5;
        this.pointRadius = 1;
        this.fill = 'false';
    }
}
